export const protocolTranslations = {
  SelectProtocolDocuments: 'Select Protocol Documents',
  ChooseFilesForEachProtocol: 'Choose files for each protocol label.',
  SelectFilesForProtocol: 'Select Files for Protocol',
  ChooseFilesForLabel: 'Choose the files that belong to this label.',
  Required: 'Required',
  Optional: 'Optional',
  ConfirmSelection: 'Confirm Selection',
  StartAutoTagging: 'Start Auto-tagging',
  UploadAdditionalFiles: 'Upload Additional Files',
  ChooseTheFilesForLabel: 'Choose the files that belong to this label.',
}
